import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const ownerStatementTemplates = [
  {
    id: '-130001',
    language: Language.EN,
    subject: 'Owner statement',
    type: TemplateType.MAIL,
    subType: TemplateSubType.OWNER_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{getContactName contact}},</p>
        <p></p>
        <p>Please find attached the document related to the management of your real estate property(ies).</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-130002',
    language: Language.FR,
    subject: 'Décompte de propriétaire',
    type: TemplateType.MAIL,
    subType: TemplateSubType.OWNER_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher {{getContactName contact}},</p>
        <p></p>
        <p>Nous vous prions de prendre connaissance du document en pièce jointe relatif à la gestion de votre/vos bien(s) immobilier(s).</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-130003',
    language: Language.NL,
    subject: 'Eigenaar rekeningen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.OWNER_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{getContactName contact}},</p>
        <p></p>
        <p>In bijlage vindt u een document dat betrekking heeft op het beheer van uw vastgoed.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-130004',
    language: Language.DE,
    subject: 'Eigentümer-Abrechnung',
    type: TemplateType.MAIL,
    subType: TemplateSubType.OWNER_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{getContactName contact}},</p>
        <p></p>
        <p>Bitte finden Sie anbei das Dokument zur Verwaltung Ihrer Immobilie(n).</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
